/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppImport } from './routes/_app'
import { Route as AppIndexImport } from './routes/_app/index'
import { Route as AuthSetPasswordImport } from './routes/_auth/set-password'
import { Route as AppOncologyRouteImport } from './routes/_app/oncology/route'
import { Route as AppQueryAnalyticsIndexImport } from './routes/_app/query-analytics/index'
import { Route as AppOncologyIndexImport } from './routes/_app/oncology/index'
import { Route as AppSystemAuditLogsIndexImport } from './routes/_app/system/audit-logs/index'
import { Route as AppSystemAiRoadmapIndexImport } from './routes/_app/system/ai-roadmap/index'
import { Route as AppReportsDemographicsIndexImport } from './routes/_app/reports/demographics/index'
import { Route as AppReportsConsentIndexImport } from './routes/_app/reports/consent/index'
import { Route as AppReportsComplianceIndexImport } from './routes/_app/reports/compliance/index'
import { Route as AppReportsBiometricsIndexImport } from './routes/_app/reports/biometrics/index'
import { Route as AppReportsBillingIndexImport } from './routes/_app/reports/billing/index'
import { Route as AppOncologyTriageIndexImport } from './routes/_app/oncology/triage/index'
import { Route as AppOncologySurvivorshipIndexImport } from './routes/_app/oncology/survivorship/index'
import { Route as AppOncologyEscalationIndexImport } from './routes/_app/oncology/escalation/index'
import { Route as AppManageUsersIndexImport } from './routes/_app/manage/users/index'
import { Route as AppManageReferralsIndexImport } from './routes/_app/manage/referrals/index'
import { Route as AppManagePatientsIndexImport } from './routes/_app/manage/patients/index'
import { Route as AppManagePathwaysIndexImport } from './routes/_app/manage/pathways/index'
import { Route as AppManageFacilitiesIndexImport } from './routes/_app/manage/facilities/index'
import { Route as AppManageDevicesIndexImport } from './routes/_app/manage/devices/index'
import { Route as AppManageCommunicationIndexImport } from './routes/_app/manage/communication/index'
import { Route as AppManageAdtTriggerRulesIndexImport } from './routes/_app/manage/adt-trigger-rules/index'
import { Route as AppManagePatientsPatientIdRouteImport } from './routes/_app/manage/patients/$patientId/route'
import { Route as AppManagePatientsPatientIdIndexImport } from './routes/_app/manage/patients/$patientId/index'
import { Route as AppManagePathwaysPathwayIdIndexImport } from './routes/_app/manage/pathways/$pathwayId/index'

// Create Virtual Routes

const BiometricCounterLazyImport = createFileRoute('/biometric-counter')()
const AuthSignInLazyImport = createFileRoute('/_auth/sign-in')()
const AuthMfaVerifyLazyImport = createFileRoute('/_auth/mfa-verify')()
const AuthForgotPasswordLazyImport = createFileRoute('/_auth/forgot-password')()
const AppWelcomeIndexLazyImport = createFileRoute('/_app/welcome/')()
const AppDashboardIndexLazyImport = createFileRoute('/_app/dashboard/')()
const AppOncologyEscalationFacilityIdLazyImport = createFileRoute(
  '/_app/oncology/escalation/$facilityId',
)()

// Create/Update Routes

const BiometricCounterLazyRoute = BiometricCounterLazyImport.update({
  path: '/biometric-counter',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/biometric-counter.lazy').then((d) => d.Route),
)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const AuthSignInLazyRoute = AuthSignInLazyImport.update({
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/sign-in.lazy').then((d) => d.Route))

const AuthMfaVerifyLazyRoute = AuthMfaVerifyLazyImport.update({
  path: '/mfa-verify',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/mfa-verify.lazy').then((d) => d.Route),
)

const AuthForgotPasswordLazyRoute = AuthForgotPasswordLazyImport.update({
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/forgot-password.lazy').then((d) => d.Route),
)

const AuthSetPasswordRoute = AuthSetPasswordImport.update({
  path: '/set-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/set-password.lazy').then((d) => d.Route),
)

const AppOncologyRouteRoute = AppOncologyRouteImport.update({
  path: '/oncology',
  getParentRoute: () => AppRoute,
} as any)

const AppWelcomeIndexLazyRoute = AppWelcomeIndexLazyImport.update({
  path: '/welcome/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/welcome/index.lazy').then((d) => d.Route),
)

const AppDashboardIndexLazyRoute = AppDashboardIndexLazyImport.update({
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/dashboard/index.lazy').then((d) => d.Route),
)

const AppQueryAnalyticsIndexRoute = AppQueryAnalyticsIndexImport.update({
  path: '/query-analytics/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/query-analytics/index.lazy').then((d) => d.Route),
)

const AppOncologyIndexRoute = AppOncologyIndexImport.update({
  path: '/',
  getParentRoute: () => AppOncologyRouteRoute,
} as any)

const AppSystemAuditLogsIndexRoute = AppSystemAuditLogsIndexImport.update({
  path: '/system/audit-logs/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/system/audit-logs/index.lazy').then((d) => d.Route),
)

const AppSystemAiRoadmapIndexRoute = AppSystemAiRoadmapIndexImport.update({
  path: '/system/ai-roadmap/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/system/ai-roadmap/index.lazy').then((d) => d.Route),
)

const AppReportsDemographicsIndexRoute =
  AppReportsDemographicsIndexImport.update({
    path: '/reports/demographics/',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/reports/demographics/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AppReportsConsentIndexRoute = AppReportsConsentIndexImport.update({
  path: '/reports/consent/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/reports/consent/index.lazy').then((d) => d.Route),
)

const AppReportsComplianceIndexRoute = AppReportsComplianceIndexImport.update({
  path: '/reports/compliance/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/reports/compliance/index.lazy').then((d) => d.Route),
)

const AppReportsBiometricsIndexRoute = AppReportsBiometricsIndexImport.update({
  path: '/reports/biometrics/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/reports/biometrics/index.lazy').then((d) => d.Route),
)

const AppReportsBillingIndexRoute = AppReportsBillingIndexImport.update({
  path: '/reports/billing/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/reports/billing/index.lazy').then((d) => d.Route),
)

const AppOncologyTriageIndexRoute = AppOncologyTriageIndexImport.update({
  path: '/triage/',
  getParentRoute: () => AppOncologyRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/oncology/triage/index.lazy').then((d) => d.Route),
)

const AppOncologySurvivorshipIndexRoute =
  AppOncologySurvivorshipIndexImport.update({
    path: '/survivorship/',
    getParentRoute: () => AppOncologyRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/oncology/survivorship/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AppOncologyEscalationIndexRoute = AppOncologyEscalationIndexImport.update(
  {
    path: '/escalation/',
    getParentRoute: () => AppOncologyRouteRoute,
  } as any,
).lazy(() =>
  import('./routes/_app/oncology/escalation/index.lazy').then((d) => d.Route),
)

const AppManageUsersIndexRoute = AppManageUsersIndexImport.update({
  path: '/manage/users/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/manage/users/index.lazy').then((d) => d.Route),
)

const AppManageReferralsIndexRoute = AppManageReferralsIndexImport.update({
  path: '/manage/referrals/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/manage/referrals/index.lazy').then((d) => d.Route),
)

const AppManagePatientsIndexRoute = AppManagePatientsIndexImport.update({
  path: '/manage/patients/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/manage/patients/index.lazy').then((d) => d.Route),
)

const AppManagePathwaysIndexRoute = AppManagePathwaysIndexImport.update({
  path: '/manage/pathways/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/manage/pathways/index.lazy').then((d) => d.Route),
)

const AppManageFacilitiesIndexRoute = AppManageFacilitiesIndexImport.update({
  path: '/manage/facilities/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/manage/facilities/index.lazy').then((d) => d.Route),
)

const AppManageDevicesIndexRoute = AppManageDevicesIndexImport.update({
  path: '/manage/devices/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/_app/manage/devices/index.lazy').then((d) => d.Route),
)

const AppManageCommunicationIndexRoute =
  AppManageCommunicationIndexImport.update({
    path: '/manage/communication/',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/manage/communication/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AppManageAdtTriggerRulesIndexRoute =
  AppManageAdtTriggerRulesIndexImport.update({
    path: '/manage/adt-trigger-rules/',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/manage/adt-trigger-rules/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AppOncologyEscalationFacilityIdLazyRoute =
  AppOncologyEscalationFacilityIdLazyImport.update({
    path: '/escalation/$facilityId',
    getParentRoute: () => AppOncologyRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/oncology/escalation/$facilityId.lazy').then(
      (d) => d.Route,
    ),
  )

const AppManagePatientsPatientIdRouteRoute =
  AppManagePatientsPatientIdRouteImport.update({
    path: '/manage/patients/$patientId',
    getParentRoute: () => AppRoute,
  } as any)

const AppManagePatientsPatientIdIndexRoute =
  AppManagePatientsPatientIdIndexImport.update({
    path: '/',
    getParentRoute: () => AppManagePatientsPatientIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/manage/patients/$patientId/index.lazy').then(
      (d) => d.Route,
    ),
  )

const AppManagePathwaysPathwayIdIndexRoute =
  AppManagePathwaysPathwayIdIndexImport.update({
    path: '/manage/pathways/$pathwayId/',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/_app/manage/pathways/$pathwayId/index.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/biometric-counter': {
      preLoaderRoute: typeof BiometricCounterLazyImport
      parentRoute: typeof rootRoute
    }
    '/_app/oncology': {
      preLoaderRoute: typeof AppOncologyRouteImport
      parentRoute: typeof AppImport
    }
    '/_auth/set-password': {
      preLoaderRoute: typeof AuthSetPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_auth/forgot-password': {
      preLoaderRoute: typeof AuthForgotPasswordLazyImport
      parentRoute: typeof AuthImport
    }
    '/_auth/mfa-verify': {
      preLoaderRoute: typeof AuthMfaVerifyLazyImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sign-in': {
      preLoaderRoute: typeof AuthSignInLazyImport
      parentRoute: typeof AuthImport
    }
    '/_app/': {
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/oncology/': {
      preLoaderRoute: typeof AppOncologyIndexImport
      parentRoute: typeof AppOncologyRouteImport
    }
    '/_app/query-analytics/': {
      preLoaderRoute: typeof AppQueryAnalyticsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard/': {
      preLoaderRoute: typeof AppDashboardIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/welcome/': {
      preLoaderRoute: typeof AppWelcomeIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/patients/$patientId': {
      preLoaderRoute: typeof AppManagePatientsPatientIdRouteImport
      parentRoute: typeof AppImport
    }
    '/_app/oncology/escalation/$facilityId': {
      preLoaderRoute: typeof AppOncologyEscalationFacilityIdLazyImport
      parentRoute: typeof AppOncologyRouteImport
    }
    '/_app/manage/adt-trigger-rules/': {
      preLoaderRoute: typeof AppManageAdtTriggerRulesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/communication/': {
      preLoaderRoute: typeof AppManageCommunicationIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/devices/': {
      preLoaderRoute: typeof AppManageDevicesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/facilities/': {
      preLoaderRoute: typeof AppManageFacilitiesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/pathways/': {
      preLoaderRoute: typeof AppManagePathwaysIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/patients/': {
      preLoaderRoute: typeof AppManagePatientsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/referrals/': {
      preLoaderRoute: typeof AppManageReferralsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/users/': {
      preLoaderRoute: typeof AppManageUsersIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/oncology/escalation/': {
      preLoaderRoute: typeof AppOncologyEscalationIndexImport
      parentRoute: typeof AppOncologyRouteImport
    }
    '/_app/oncology/survivorship/': {
      preLoaderRoute: typeof AppOncologySurvivorshipIndexImport
      parentRoute: typeof AppOncologyRouteImport
    }
    '/_app/oncology/triage/': {
      preLoaderRoute: typeof AppOncologyTriageIndexImport
      parentRoute: typeof AppOncologyRouteImport
    }
    '/_app/reports/billing/': {
      preLoaderRoute: typeof AppReportsBillingIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/biometrics/': {
      preLoaderRoute: typeof AppReportsBiometricsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/compliance/': {
      preLoaderRoute: typeof AppReportsComplianceIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/consent/': {
      preLoaderRoute: typeof AppReportsConsentIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/reports/demographics/': {
      preLoaderRoute: typeof AppReportsDemographicsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/system/ai-roadmap/': {
      preLoaderRoute: typeof AppSystemAiRoadmapIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/system/audit-logs/': {
      preLoaderRoute: typeof AppSystemAuditLogsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/pathways/$pathwayId/': {
      preLoaderRoute: typeof AppManagePathwaysPathwayIdIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/manage/patients/$patientId/': {
      preLoaderRoute: typeof AppManagePatientsPatientIdIndexImport
      parentRoute: typeof AppManagePatientsPatientIdRouteImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  AppRoute.addChildren([
    AppOncologyRouteRoute.addChildren([
      AppOncologyIndexRoute,
      AppOncologyEscalationFacilityIdLazyRoute,
      AppOncologyEscalationIndexRoute,
      AppOncologySurvivorshipIndexRoute,
      AppOncologyTriageIndexRoute,
    ]),
    AppIndexRoute,
    AppQueryAnalyticsIndexRoute,
    AppDashboardIndexLazyRoute,
    AppWelcomeIndexLazyRoute,
    AppManagePatientsPatientIdRouteRoute.addChildren([
      AppManagePatientsPatientIdIndexRoute,
    ]),
    AppManageAdtTriggerRulesIndexRoute,
    AppManageCommunicationIndexRoute,
    AppManageDevicesIndexRoute,
    AppManageFacilitiesIndexRoute,
    AppManagePathwaysIndexRoute,
    AppManagePatientsIndexRoute,
    AppManageReferralsIndexRoute,
    AppManageUsersIndexRoute,
    AppReportsBillingIndexRoute,
    AppReportsBiometricsIndexRoute,
    AppReportsComplianceIndexRoute,
    AppReportsConsentIndexRoute,
    AppReportsDemographicsIndexRoute,
    AppSystemAiRoadmapIndexRoute,
    AppSystemAuditLogsIndexRoute,
    AppManagePathwaysPathwayIdIndexRoute,
  ]),
  AuthRoute.addChildren([
    AuthSetPasswordRoute,
    AuthForgotPasswordLazyRoute,
    AuthMfaVerifyLazyRoute,
    AuthSignInLazyRoute,
  ]),
  BiometricCounterLazyRoute,
])

/* prettier-ignore-end */
